import { render, staticRenderFns } from "./product-impact-list.vue?vue&type=template&id=0963e7e2&scoped=true"
import script from "./product-impact-list.vue?vue&type=script&lang=js"
export * from "./product-impact-list.vue?vue&type=script&lang=js"
import style0 from "./product-impact-list.vue?vue&type=style&index=0&id=0963e7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963e7e2",
  null
  
)

export default component.exports